import { CornerUpLeft, ReplyAll, Forward } from "lucide-react";

// Barre d'écriture e-mail : actions Répondre / Répondre à tous / Transférer + les
// champs À / Cc / Cci (et Objet en transfert), éditables. Le corps reste le
// textarea du composer. Les valeurs sont contrôlées par le Thread (qui les
// préremplit selon l'action et les passe à l'envoi).

export type EmailMode = "reply" | "reply-all" | "forward";

export function EmailComposeBar({
  mode,
  onPick,
  to,
  setTo,
  cc,
  setCc,
  bcc,
  setBcc,
  subject,
  setSubject,
  showCc,
  setShowCc,
}: {
  mode: EmailMode | null;
  onPick: (m: EmailMode) => void;
  to: string;
  setTo: (v: string) => void;
  cc: string;
  setCc: (v: string) => void;
  bcc: string;
  setBcc: (v: string) => void;
  subject: string;
  setSubject: (v: string) => void;
  showCc: boolean;
  setShowCc: (v: boolean) => void;
}) {
  return (
    <div className="email-compose">
      <div className="email-compose-actions" role="group" aria-label="Actions e-mail">
        <button
          type="button"
          className={mode === "reply" ? "active" : ""}
          onClick={() => onPick("reply")}
        >
          <CornerUpLeft size={14} /> Répondre
        </button>
        <button
          type="button"
          className={mode === "reply-all" ? "active" : ""}
          onClick={() => onPick("reply-all")}
        >
          <ReplyAll size={14} /> Répondre à tous
        </button>
        <button
          type="button"
          className={mode === "forward" ? "active" : ""}
          onClick={() => onPick("forward")}
        >
          <Forward size={14} /> Transférer
        </button>
      </div>
      {mode && (
        <div className="email-compose-fields">
          <label className="email-field">
            <span>À</span>
            <input
              value={to}
              onChange={(e) => setTo(e.target.value)}
              placeholder="destinataires, séparés par des virgules"
              autoComplete="off"
            />
            {!showCc && (
              <button type="button" className="email-field-more" onClick={() => setShowCc(true)}>
                Cc/Cci
              </button>
            )}
          </label>
          {showCc && (
            <>
              <label className="email-field">
                <span>Cc</span>
                <input value={cc} onChange={(e) => setCc(e.target.value)} autoComplete="off" />
              </label>
              <label className="email-field">
                <span>Cci</span>
                <input value={bcc} onChange={(e) => setBcc(e.target.value)} autoComplete="off" />
              </label>
            </>
          )}
          {mode === "forward" && (
            <label className="email-field">
              <span>Objet</span>
              <input
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                autoComplete="off"
              />
            </label>
          )}
        </div>
      )}
    </div>
  );
}
